var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 5.872c-6.479 0-11.729 5.251-11.729 11.729 0 2.939 1.084 5.625 2.872 7.683l-2.744 3.363.826.674 2.659-3.258a11.686 11.686 0 0 0 8.116 3.265 11.69 11.69 0 0 0 8.132-3.281l2.657 3.278.829-.672-2.746-3.387a11.682 11.682 0 0 0 2.857-7.666c0-6.478-5.252-11.729-11.729-11.729zm0 22.39c-5.88 0-10.662-4.782-10.662-10.661 0-5.88 4.783-10.662 10.662-10.662s10.663 4.783 10.663 10.662c0 5.879-4.783 10.661-10.662 10.661zM11.171 2.672H8.003a5.33 5.33 0 0 0-5.331 5.331v3.208h1.516l6.983-7.022V2.672zM10.104 3.75l-6.366 6.395V8.003a4.27 4.27 0 0 1 4.265-4.265h2.101v.011zM23.997 2.672h-3.17v1.517l6.984 7.022h1.517V8.003a5.331 5.331 0 0 0-5.331-5.331zm4.265 7.473h-.007L21.894 3.75v-.011h2.103a4.27 4.27 0 0 1 4.265 4.265v2.142z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.467 17.599H9.589v1.066h6.944V9.069h-1.066z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.0c37b0f322e3b34d6827e9d5b2252809.svg";
export { ForwardRef as ReactComponent };